import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { IN_APP_VIEW_OPTIONS } from '../constants';
import { PreviewWithDataErrorMessage } from '../../common';

export interface InAppPreviewContextState {
  isLoading: boolean;
  messageHtml: string;
  messageInboxSubtitle: string;
  messageInboxTitle: string;
  messageRawDataPayload: string;
  messageRokuHeader: string;
  messageRokuBody: string;
  onRefreshPreview: NoOp;
  previewError?: PreviewWithDataErrorMessage;
  previewViewOption: IN_APP_VIEW_OPTIONS;
  setPreviewViewOption: (val: IN_APP_VIEW_OPTIONS) => void;
}

export const InAppPreviewContext = createContext<InAppPreviewContextState>({
  isLoading: false,
  messageHtml: '',
  messageInboxSubtitle: '',
  messageInboxTitle: '',
  messageRawDataPayload: '{}',
  messageRokuHeader: '',
  messageRokuBody: '',
  onRefreshPreview: noop,
  previewError: undefined,
  previewViewOption: IN_APP_VIEW_OPTIONS.inApp,
  setPreviewViewOption: noop,
});

export const useInAppPreviewContext = () => useContext(InAppPreviewContext);
